import { render, staticRenderFns } from "./ChipDeliverGoodsDailyPaper.vue?vue&type=template&id=15aac542&scoped=true&"
import script from "./ChipDeliverGoodsDailyPaper.vue?vue&type=script&lang=js&"
export * from "./ChipDeliverGoodsDailyPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aac542",
  null
  
)

export default component.exports